import * as React from 'react';
import { withStyles } from "@material-ui/core";
import Icon from "storybookComponents/Icon"
import ExportReport from "./ExportComponent/exportReport"
import EmailReport from "./ExportComponent/emailReport"
import ScheduleReport from "./ExportComponent/scheduleReport"

const styles = () => ({
  super: {
    width: "300px",
    background: "white",
    height: "100vh"
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 20px",
    fontSize: 20,
    lineHeight: "30px",
    color: "rgba(0, 0, 0, 1)",
    borderBottom: "1px solid #dadada"
  },
  closeIcon: {
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed"
    }
  },
  bodyContainer: {
    padding: "15px 20px",
  },
  bottom: {
    position: 'absolute',
    padding: "24px 20px",
    width: "100%",
    bottom: 0,
    textAlign: 'right',
  },
  btnStyle: {
    height: 40,
    padding: "10px 16px",
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    marginLeft: 12,
    textTransform: "none"

  },
  header: {
    fontSize: 14,
    color: "#333333",
    opacity: "0.7",
    marginBottom: "14px"
  },
  subtitle: {
    fontSize: 12,
    color: "#333333",
    opacity: "0.7",
    fontStyle: "italic"
  },
  bottomFlexBox: {
    width: "100%",
    textAlign: "right",
    marginTop: "24px",
  },
  label: {
    fontSize: 12,
    color: "#333333",
    opacity: 0.7,
    lineHeight: '24px',
    fontFamily: 'Open Sans',
  },
  emailFieldContainer: {
    paddingRight: "0px",
    marginTop: "14px"
  },
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
    fontWeight: 600,
    color: "#333333",
    opacity: "0.75",
    width: 225
  },
  placeholder: {
    color: "#333333",
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600,
    opacity: "0.75"
  },
  openOpacity: {
    opacity: "1"
  },
  selectFieldContainer: {
    width: "100%",
    borderBottom: "1px solid #dadada",
    marginTop: 24,
    marginBottom: 10
  }
});



export default withStyles(styles)(({ classes, title, onClose, id, showNotification }) => {
  return (
    <div className={classes.super}>
      <div className={classes.flexBox}>
        {title}
        <div className={classes.closeIcon}>
          <Icon onClick={onClose} type="icon-e-remove" size="lg" />
        </div>
      </div>
      <div className={classes.bodyContainer}>
        {
          title == "Email Report" ? <EmailReport classes={classes} onClose={onClose} /> : null
        }
        {
          title == "Schedule Email" ? <ScheduleReport classes={classes} onClose={onClose} /> : null
        }
        {
          title == "Export Report" ? <ExportReport classes={classes} onClose={onClose} id={id} showNotification={showNotification} /> : null
        }

        {
          //Duplicate Report
        }
      </div>
    </div>
  );
})